import type { Column } from '@/components_deprecated/Table'
import { durationAsSecondsToString } from '@/utils/time'
import { useTranslate } from '@ur-solutions/react-hooks'
import React from 'react'
import { sumTimeEntryHours } from '../sum-time-entry-hours'
import type { UserTimeEntryNode } from '../types.graphql'

const HOURS_COLUMN = 'totalWork'

interface SalaryTimeEntriesSummationProps {
  columns: Column[]
  entries: UserTimeEntryNode[]
}

/**
 * Sum row closing the salary time entries table. The cells are laid out from
 * the same `columns` the table header is built from, plus the trailing row
 * menu column, so the total stays under the hours it sums.
 */
export const SalaryTimeEntriesSummation: React.FC<
  SalaryTimeEntriesSummationProps
> = ({ columns, entries }) => {
  const translations = useTranslate({
    sum: 'common.sum',
  })

  const total = durationAsSecondsToString(sumTimeEntryHours(entries))

  return (
    <tr className="bg-quaternary font-semibold">
      {columns.map((column, index) => (
        <td key={column.name}>
          {index === 0 && translations.sum}
          {column.name === HOURS_COLUMN && total}
        </td>
      ))}

      <td />
    </tr>
  )
}
